export type MiscTaskTypeId =
  | 'Admission Consents'
  | 'Other Documents'
  | 'Discharge Consents'
  | 'Patient Consent'
  | 'Assignment of Benefits'
  | 'Eligibility Check'
  | 'E-Referral'
  | 'Get Authorization'
  | 'Do Not Resuscitate (DNR) Order'
  | 'Power of Attorney (POA)'
  | 'Emergency Department Documents'
  | 'History and Physical'
  | 'Hospitalization Report'
  | 'Intake Documents'
  | 'Lab Results'
  | 'Imaging Results'
  | 'Notice of Medicare Non-Coverage (NOMNC)'
  | 'Patient Emergency Plan'
  | 'Provider Progress Note'
  | 'Resumption of Care Documents'
  | 'Care Plan Synopsis (CPS)'
  | 'Case Conference';

/**
 * Type of miscellaneous episode task.

Values are the human-readable labels shown in the Episode Manager, so the
task list can use them as ``display_name`` without a lookup table. The
backing column is a plain ``String``, so adding a member here needs no
migration.
 */
/**
 * Array of all MiscTaskTypeId values.
 * Type of miscellaneous episode task.

Values are the human-readable labels shown in the Episode Manager, so the
task list can use them as ``display_name`` without a lookup table. The
backing column is a plain ``String``, so adding a member here needs no
migration.
 */
export const MISCTASKTYPEID_VALUES: readonly MiscTaskTypeId[] = [
  'Admission Consents',
  'Other Documents',
  'Discharge Consents',
  'Patient Consent',
  'Assignment of Benefits',
  'Eligibility Check',
  'E-Referral',
  'Get Authorization',
  'Do Not Resuscitate (DNR) Order',
  'Power of Attorney (POA)',
  'Emergency Department Documents',
  'History and Physical',
  'Hospitalization Report',
  'Intake Documents',
  'Lab Results',
  'Imaging Results',
  'Notice of Medicare Non-Coverage (NOMNC)',
  'Patient Emergency Plan',
  'Provider Progress Note',
  'Resumption of Care Documents',
  'Care Plan Synopsis (CPS)',
  'Case Conference',
] as const;
